export const ENROLL = 'enroll';
export const ENROLL_AUTOMATICALLY = 'autoenroll';

export default {
  ENROLL,
};
